<template>
  <v-simple-table dense>
    <thead>
      <tr>
        <th>営業日</th>
        <th>区分</th>
        <th>名前</th>
        <th class="text-right">
          金額
        </th>
        <th>現金区分</th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="(item, index) in items"
        :key="index"
      >
        <td>{{ item.date }}</td>
        <td>{{ kindLabel(item.kind) }}</td>
        <td>{{ item.name }}</td>
        <td class="text-right">
          {{ formatAmount(item.amount) }}
        </td>
        <td>{{ item.isCash ? '現金' : '非現金' }}</td>
      </tr>
      <tr v-if="items.length === 0">
        <td
          colspan="5"
          class="text-center"
        >
          データがありません
        </td>
      </tr>
    </tbody>
  </v-simple-table>
</template>

<script>
export default {
  name: 'BenefitsExpensesTable',
  props: {
    items: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    formatAmount(amount) {
      if (amount == null) return '-'

      return `¥${Number(amount).toLocaleString()}`
    },
    kindLabel(kind) {
      if (kind === 'benefit') return 'その他収入'
      if (kind === 'expense') return 'その他経費'

      return kind
    },
  },
}
</script>
